<mat-icon class="attributes-button" (click)="openAttributesPopup()">settings
</mat-icon>
